import React from 'react';

export const Interactions = props => {
  return <React.Fragment>{props.children}</React.Fragment>;
};
